document.addEventListener("DOMContentLoaded", function() {
  const forms = document.querySelectorAll('.product-section__inner__form, .state-featured-product-form');
  if (forms.length === 0) return;
  forms.forEach(form => {
    form.addEventListener('submit', async function(e) {
      e.preventDefault();
      const formData = new FormData(form);
      const addButton = form.querySelector('[type="submit"]');
      if (!addButton) return;
      try {
        addButton.disabled = true;
        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: {
            'Accept': 'application/json',
          },
        });

        if (!addResponse.ok) throw new Error("Add to cart failed");
        const cartResponse = await fetch('/cart.js');
        const cartData = await cartResponse.json();
        updateCartCount(cartData.item_count);
        const drawerResponse = await fetch('/?section_id=cart-drawer');
        const html = await drawerResponse.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newCartDrawer = doc.querySelector('cart-drawer');
        
        if (newCartDrawer) {
          const currentCartDrawer = document.querySelector('cart-drawer');
          if (currentCartDrawer) {
            currentCartDrawer.replaceWith(newCartDrawer);
            newCartDrawer.classList.add('animate', 'active');
            document.body.classList.add('drawer-open');
          }
        }

      } catch (error) {
        console.error('Cart error:', error);
        const errorContainer = document.querySelector('#CartDrawer-CartErrors');
        if (errorContainer) {
          errorContainer.textContent = 'Could not update cart. Please try again.';
          setTimeout(() => errorContainer.textContent = '', 5000);
        }
      } finally {
        addButton.disabled = false;
      }
    });
  });

  function updateCartCount(count) {
    const cartIconBubble = document.getElementById('cart-icon-bubbl');
    if (cartIconBubble) {
      const cartCountSpan = cartIconBubble.querySelector('#cart-count');
      if (cartCountSpan) {
        if (count === 0) {
          cartCountSpan.textContent = 'CART(0)';
        } else {
          cartCountSpan.textContent = `CART (${count})`;
        }
      }
    }

    const cartIconBubblee = document.getElementById('cart-icon-bubblee');
    if (cartIconBubblee) {
      const cartCountSpan = cartIconBubblee.querySelector('#mob-cart-count');
      if (cartCountSpan) {
        if (count === 0) {
          cartCountSpan.textContent = '0';
        } else {
          cartCountSpan.textContent = count;
        }
      }
    }
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('#CartDrawer-Checkout');
    if (button) {
      console.log("Redirecting to cart...");
      window.location.href = '/cart';
    }
  });
});
